module.exports = __webpack_public_path__ + "static/media/fly0049.b9fa9274.webp";